import {
  MemberProductLevelEnum,
  PayChannel,
  type MemberProduct,
} from "@features/api/memberApi";
import { useOnboardingHarnessQuery } from "./useOnboardingHarnessQuery";

const product = (
  id: string,
  pay_cycle: MemberProduct["pay_cycle"],
  price: string,
): MemberProduct => ({
  id: `harness-${id}`,
  name: "expert",
  level: MemberProductLevelEnum.EXPERT,
  type: "NORMAL",
  status: "ACTIVE",
  pay_cycle,
  price,
  payment_configs: [
    { channel: PayChannel.STRIPE, status: "ACTIVE" },
    { channel: PayChannel.PAYPAL, status: "ACTIVE" },
  ],
});

export const ONBOARDING_PRICING_HARNESS_FIXTURE = {
  data: [
    product("annual", "YEAR", "299.99"),
    product("monthly", "MONTH", "39.99"),
    product("weekly", "WEEK", "14.99"),
    product("lifetime", "LIFETIME", "899.99"),
  ],
  trialList: [
    {
      ...product("trial", "DAY", "0"),
      payment_configs: [PayChannel.STRIPE, PayChannel.PAYPAL].map(
        (channel) => ({
          channel,
          status: "ACTIVE",
          offers: [{ status: "ACTIVE", trial_period_days: 7 }],
        }),
      ),
      type: "TRIAL",
      renewal_id: "harness-annual",
    },
  ] as MemberProduct[],
};

export function useOnboardingPricingFixture() {
  const harness = useOnboardingHarnessQuery();
  return harness.enabled && harness.pricingFixture
    ? ONBOARDING_PRICING_HARNESS_FIXTURE
    : undefined;
}
